/* eslint-disable react/jsx-no-undef */
import React from "react";

// import { useNavigate } from "react-router-dom";

import PrimaryButton from "../../components/button/PrimaryButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import backgroundSuccess from '../../assets/images/register/bg-success.png';
import imageSuccess from '../../assets/images/register/img-success.png';
import haierClub from '../../assets/images/haier-privilage.png';
import useWindowDimensions from "../../functions/getScreen";

export default function RegisterSuccess() {
  const store = useSelector((state) => state.RegisterShop)
  const { width } = useWindowDimensions();
  console.log(width)

  const navigate = useNavigate();
  return (
    <>
      {/* <PopupRegisterSuccess
        // point={state.point}
        actionFunction={() => {
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      /> */}
      <TopLogo />
      <div
        style={{
          background: `url(${backgroundSuccess}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "20px",
          backgroundSize: "cover"
        }}
      >
        <div className="text-white text-center text-[30px] mt-[50px]">
          สมัครสมาชิกสำเร็จ
        </div>
        <div className="w-fit mx-auto text-white text-center text-[24px]">
          ขอบคุณที่เป็นส่วนหนึ่งของ
          <img
            className="mt-[5px] h-[25px] mx-auto"
            src={haierClub}
            alt="logo"
          />
        </div>
        <img
          className="mx-auto mt-[20px]"
          src={imageSuccess}
          alt="logo"
          style={{ width: "40%" }}
        />
        {/* <div className="text-white text-center text-[24px]">
          สิทธิพิเศษมากมายจาก{" "}
          <img
            src={LogoSpectra}
            alt="logo"
            style={{ width: "70px", display: "inline-block" }}
          />{" "}
          รอคุณอยู่
        </div> */}
        <div className="text-center mt-[50px]">
          {/*btn member*/}
          {!store['shopCode'] &&
            <div className="my-4">
              <PrimaryButton
                variant="contained"
                className="w-[70%] !bg-[#082e683d]"
                onClick={() => {
                  navigate('/member-info')
                }}
                sx={{
                  border: "1px solid white"
                }}
              >
                ไปหน้าโปรไฟล์
              </PrimaryButton>
            </div>
          }
          {store['shopCode'] &&
            <div className="my-4">
              <PrimaryButton
                variant="contained"
                className="w-[70%] !bg-[#082e683d]"
                onClick={() => {
                  navigate('/shop-info')
                }}
                sx={{
                  border: "1px solid white"
                }}
              >
                ไปหน้าโปรไฟล์
              </PrimaryButton>
            </div>
          }
          {/*btn member*/}
          {/* {!store['isPetShop'] &&
            <div className="my-4">
              <SecondaryButton
                variant="contained"
                className="w-[70%] !bg-[#8FC8F5]"
                onClick={() => {
                }}
                sx={{
                  border: "1px solid white"
                }}
              >
                เพิ่มที่อยู่
              </SecondaryButton>
            </div>
          } */}
        </div>
      </div>
    </>
  );
}
